import { styled } from "@mui/material/styles";

import {
  IconButton,
  IconButtonProps,
} from "@/components/ui-v2/IconButton/IconButton";

// eslint-disable-next-line
export interface TileButtonProps extends IconButtonProps {}

const Root = styled(IconButton)(() => ({
  position: "relative",
  display: "flex",
  zIndex: 10,
  width: "2em",
  height: "2em",
  fontSize: "0.8em",
  minWidth: 0,
  minHeight: 0,
  maxWidth: "none",
  maxHeight: "none",
}));

export const TileButton = (props: TileButtonProps) => {
  return <Root variant="white" {...props} />;
};
